import { render, staticRenderFns } from "./translationNouns.vue?vue&type=template&id=037195ea&scoped=true&"
import script from "./translationNouns.vue?vue&type=script&lang=js&"
export * from "./translationNouns.vue?vue&type=script&lang=js&"
import style0 from "./translationNouns.vue?vue&type=style&index=0&id=037195ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037195ea",
  null
  
)

export default component.exports